import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Bank } from '../../../class/bank';
import { BankService } from '../../../service/bank/bank.service';
import { TranslateService } from '@ngx-translate/core';
import { MapsAPILoader } from '@agm/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { Marker } from '../../../../../interfaces/marker';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';

@Component({
  selector: 'app-new-bank',
  templateUrl: './new-bank.component.html',
  styleUrls: ['./new-bank.component.scss']
})
export class NewBankComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: Bank;
    public promiseForm: Promise<any>;
    public form: FormGroup;
    public name: AbstractControl;
    public activated: AbstractControl;

    public save_exit: boolean;

    constructor(
        fb: FormBuilder,
        public bankService: BankService,
        public translate: TranslateService,
        private ngZone: NgZone,
        private notificationsService: NotificationsService,
        private mapsAPILoader: MapsAPILoader) {

        this.save_exit = false;

        this.form = fb.group({
            'name': ['', Validators.compose([Validators.required, Validators.minLength(2)])],
            'activated': ['', Validators.compose([Validators.required])],
        });

        this.name = this.form.controls['name'];
        this.activated = this.form.controls['activated'];
    }

    ngOnInit() {
        if (this.edit) {
            this.name.setValue(this.edit.name);
            this.activated.setValue(this.edit.activated);
        } else {
            this.activated.setValue(true);
        }
    }

    public cancelBank () {
        console.log('reset');
        this.form.reset();
        this.close.emit(true);
    }

    public saveandexit (values){
        this.save_exit = true;
        this.newBank(values);
    }

    public newBank(values) {
        const param = {
            'name': values.name,
            'activated': values.activated,
        };
        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.bankService.updateBank(this.edit.id, param)
                :
                this.bankService.newBank(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        if (this.save_exit) {
                            this.close.emit(true);
                            this.form.reset();
                            this.save_exit = false;
                        }
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/banks/new-bank/new-bank.component.ts